var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "section",
    { staticClass: "form-fields-third-to-add flex-column" },
    [
      _vm.hasCompany
        ? _c("form-fields-companies-list", {
            staticClass: "br b-1-gray-05 gray-0-bkg px-3",
            attrs: {
              company: _vm.company,
              overview: false,
              allowEdit: true,
              allowRemove: true,
              allowBadge: "",
              third: _vm.third,
              prop: "companySelected",
              dataBotsContext: _vm.currentStore
            },
            on: { "remove-company": _vm.remove, "edit-company": _vm.edit }
          })
        : _vm._e(),
      _vm._v(" "),
      !_vm.hasCompany
        ? _c(
            "el-form-item",
            { attrs: { prop: "companyName", label: _vm.searchLabel } },
            [
              _c("dropdown-search-third", {
                ref: "dropdownSearchThird",
                attrs: {
                  searchDisabled: _vm.searchDisabled,
                  currentStore: _vm.currentStore,
                  value: _vm.name,
                  third: _vm.third
                },
                on: { update: _vm.setThird }
              })
            ],
            1
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }